export default (X) => {

  let top = {
    invoke(options) {
      // To support api alias, we need to get api info from api map.
      let api = X.getApiByAlias(options.query.method);
      options.api = api || {
        type: X.API_TYPE.TOP,
        uri: options.query.method,
      };

      return X.call(options);
    }
  };

  return top;
}



// WEBPACK FOOTER //
// ./src/plugins/qianniu-pc-top.js